var blogs = new function () {
    this.doChangeCategory = function (event, el) {
        document.location = $(el).val();
    };
}